<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "CheckoutMainPage"
};
</script>

<style></style>
